/**
 * Constants for CreateBatchDialog and related components.
 * Extracted from CreateBatchDialog.tsx to avoid magic numbers.
 */

import { WorkflowFlowType } from '../../../types/workflow';

/**
 * Default workflow flow type - "LabTriggered" (Path C) is the default.
 */
export const DEFAULT_WORKFLOW_FLOW_TYPE: WorkflowFlowType = 'LabTriggered';

/**
 * Workflow form constants for page sizes.
 */
export const WORKFLOW_FORM_CONSTANTS = {
  PAGE_SIZES: {
    FARMERS: 500,
    FARMS: 500,
    BATCHES: 100,
  },
} as const;

/**
 * Default form values for CreateBatchDialog.
 */
export const DEFAULT_FORM_VALUES = {
  batchId: null,
  billingEntity: null,
  supplier: null,
  brand: null,
  salesAgent: null,
  priority: 'Normal' as const,
  clientReference: '',
  farmerId: null,
  farmId: null,
  labInstructions: '',
};
